import React from 'react';

import get from 'lodash/get';

import {
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
} from '@gogame/components';
import { rangePresets } from '@gogame/intl-ts';
import { ScreenLink } from '@gogame/screens';

import {
  FILTER_AFFILIATES as CAMPAIGNS_FILTER_AFFILIATES,
  FILTER_PERIOD as CAMPAIGNS_FILTER_PERIOD,
  FILTER_TYPES as CAMPAIGNS_FILTER_TYPES,
} from 'scenes/Campaigns/constants';
import { campaignsLink } from 'scenes/Campaigns/GGCampaigns/navigation';
import {
  FILTER_PERIOD as TRACKER_FILTER_PERIOD,
  FILTER_AFFILIATES as TRACKER_FILTER_AFFILIATES,
} from 'scenes/Trackers/Tracker/constants';
import { trackerLink } from 'scenes/Trackers/Tracker/navigation';

const RelatedEntitiesSection = ({ data }) => {
  return (
    <TableContainer>
      <Table width={'100%'}>
        <TableBody>
          <TableRow>
            <TableCell>
              <ScreenLink
                href={get(data, 'campaignsUrl')}
                link={campaignsLink}
                params={{
                  ready: true,
                  filters: {
                    [CAMPAIGNS_FILTER_AFFILIATES]: [data.id],
                    [CAMPAIGNS_FILTER_PERIOD]: rangePresets.LIFETIME.value,
                    [CAMPAIGNS_FILTER_TYPES]: [],
                  },
                }}
                target={'_blank'}
              >
                Campaigns
              </ScreenLink>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <ScreenLink
                link={trackerLink}
                params={{
                  ready: true,
                  filtersCollection: [
                    {
                      [TRACKER_FILTER_PERIOD]: rangePresets.LAST_30_DAYS.value,
                      [TRACKER_FILTER_AFFILIATES]: [data.id],
                    },
                  ],
                }}
                target={'_blank'}
              >
                Tracker
              </ScreenLink>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RelatedEntitiesSection;
